import { Navigate, useNavigate, useParams } from "react-router-dom";

export function useLangNavigate() {
    const navigate = useNavigate();
    const { lng } = useParams();

    return (path = "", options = {}) => {
        navigate(`/${lng}${path ? "/" + path : ""}`, options);
    };
}

export function LangNavigate({
    to = "",
    replace = false,
    state
}) {
    const { lng } = useParams();

    return (
        <Navigate
            to={`/${lng}${to ? "/" + to.replace(/^\/+/, "") : ""}`}
            replace={replace}
            state={state}
        />
    );
}